import MapServiceModel from '@/models/MapServiceModel';
import doc             from '@widesk-core/decorators/doc';
import { PlanUnresolvedGlyph } from '@models/map/dxfTypes';

/**
 * Opération custom `POST /imports/{id}/plan/glyphs` : dictionnaire de glyphes.
 *
 * Sans `entries`, c'est une LECTURE — les signatures restant à étiqueter, triées par
 * fréquence, chacune avec sa vignette. Avec `entries`, l'étiquetage est enregistré à la
 * portée demandée et le rapport revient rafraîchi.
 *
 * Ne concerne que les formats dont les numéros sont VECTORISÉS (SVG de classe A, PDF à
 * texte vectorisé) : un DXF, qui porte son texte en clair, se voit refuser l'opération.
 *
 * Appel : `setId(importId).save({ method: 'post', patchAttributes: { entries, scope } })`.
 */
@doc.path('/imports/{id}/plan/glyphs')
export default class PlanGlyphsModel extends MapServiceModel {
	@doc.string declare fontKey: string;
	@doc.number declare totalGlyphs: number;
	@doc.number declare resolvedGlyphs: number;
	@doc.number declare totalLabels: number;
	@doc.number declare readableLabels: number;
	@doc.number declare glyphCoverage: number;
	@doc.number declare labelCoverage: number;
	@doc.json   declare unresolved: PlanUnresolvedGlyph[];
}
